(() => {
const $e52e951c0fd1bee6$export$9d8e10a1281777d0 = (selector)=>{
    if (selector !== null && selector !== undefined) return true;
    else return false;
};
const $e52e951c0fd1bee6$export$d16800b7e59a8051 = (el, wrap = document)=>{
    if (el == null) return undefined;
    if (typeof el === "string") try {
        return wrap.querySelector(el) || undefined;
    } catch ({ message: message }) {
        console.error(message);
        return undefined;
    }
};
const $e52e951c0fd1bee6$export$73eac51a39d6b0eb = (el, wrap = document)=>{
    if (el == null) return undefined;
    if (typeof el === "string") try {
        return wrap.querySelectorAll(el) || undefined;
    } catch ({ message: message }) {
        console.error(message);
        return undefined;
    }
};
const $e52e951c0fd1bee6$export$1d567c320f4763bc = (el, property)=>window.getComputedStyle(el).getPropertyValue(property);
const $e52e951c0fd1bee6$export$dbf350e5966cf602 = (el, css)=>{
    Object.keys(css).forEach((prop)=>{
        el.style[prop] = css[prop];
    });
};
const $e52e951c0fd1bee6$export$28ee1007e174a2a6 = (callback)=>{
    if (document.readyState !== "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
};
const $e52e951c0fd1bee6$export$4d721c3bfe35a861 = (e)=>{
    e.cancelable !== false && e.preventDefault();
    e.stopPropagation();
};
const $e52e951c0fd1bee6$export$deed561b1a0ff1ea = (target, duration = 500)=>{
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + "ms";
    target.style.boxSizing = "border-box";
    target.style.height = target.offsetHeight + "px";
    target.offsetHeight;
    target.style.overflow = "hidden";
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    window.setTimeout(()=>{
        target.style.display = "none";
        target.style.removeProperty("height");
        target.style.removeProperty("padding-top");
        target.style.removeProperty("padding-bottom");
        target.style.removeProperty("margin-top");
        target.style.removeProperty("margin-bottom");
        target.style.removeProperty("overflow");
        target.style.removeProperty("transition-duration");
        target.style.removeProperty("transition-property");
    //alert("!");
    }, duration);
};
const $e52e951c0fd1bee6$export$abdd11a06a163232 = (target, duration = 500, displayStyle = "block")=>{
    target.style.removeProperty("display");
    let display = window.getComputedStyle(target).display;
    if (display === "none") display = displayStyle;
    target.style.display = display;
    let height = target.offsetHeight;
    target.style.overflow = "hidden";
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.offsetHeight;
    target.style.boxSizing = "border-box";
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + "ms";
    target.style.height = height + "px";
    target.style.removeProperty("padding-top");
    target.style.removeProperty("padding-bottom");
    target.style.removeProperty("margin-top");
    target.style.removeProperty("margin-bottom");
    window.setTimeout(()=>{
        target.style.removeProperty("height");
        target.style.removeProperty("overflow");
        target.style.removeProperty("transition-duration");
        target.style.removeProperty("transition-property");
    }, duration);
};
const $e52e951c0fd1bee6$export$715de50cedc228a8 = (target, duration = 500, displayStyle = "block")=>{
    if (window.getComputedStyle(target).display === "none") return $e52e951c0fd1bee6$export$abdd11a06a163232(target, duration, displayStyle);
    else return $e52e951c0fd1bee6$export$deed561b1a0ff1ea(target, duration);
};
const $e52e951c0fd1bee6$export$8c8705df4a2dcec9 = function(event, elem, callback, capture) {
    if (typeof elem === "function") {
        capture = callback;
        callback = elem;
        elem = window;
    }
    capture = capture ? true : false;
    elem = typeof elem === "string" ? document.querySelector(elem) : elem;
    if (!elem) return;
    elem.removeEventListener(event, callback, capture);
};
const $e52e951c0fd1bee6$export$a41d61df4ac70627 = (date)=>{
    let dateObj = void 0;
    if (typeof date === "string") dateObj = new Date(date);
    else dateObj = date;
    let options = {
        month: "long",
        day: "numeric"
    };
    let dateYear = dateObj.toLocaleString("latn", {
        year: "numeric"
    });
    let dateMonth = dateObj.toLocaleString("latn", {
        month: "numeric"
    });
    let dateDay = dateObj.toLocaleString("latn", {
        day: "numeric"
    });
    let dateHour = dateObj.getHours();
    let dateMinute = dateObj.getMinutes();
    let now = new Date();
    let nowYear = now.toLocaleString("latn", {
        year: "numeric"
    });
    let nowMonth = now.toLocaleString("latn", {
        month: "numeric"
    });
    let nowDay = now.toLocaleString("latn", {
        day: "numeric"
    });
    let nowHour = now.getHours();
    let nowMinute = now.getMinutes();
    // set year only if not the same year as now
    if (dateYear !== nowYear) options.year = "numeric";
    // if today, display relative time
    if (dateYear === nowYear && dateMonth === nowMonth && dateDay === nowDay) {
        let diffHour = nowHour - dateHour;
        let diffMinute = Math.abs(nowMinute - dateMinute);
        if (diffHour === 0 && diffMinute > 30) return "1 h";
        else if (diffHour === 0) return diffMinute + " min";
        else if (diffMinute >= 30) return diffHour + 1 + " h";
        return diffHour + " h";
    }
    return dateObj.toLocaleString("latn", options);
};
const $e52e951c0fd1bee6$export$110700823644f4a6 = (name, value, days)=>{
    let expires = "";
    if (days) {
        let date = new Date();
        date.setTime(date.getTime() + days * 86400000);
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
};
const $e52e951c0fd1bee6$export$4be65e66cfa2648a = (name)=>{
    let nameEQ = name + "=";
    let ca = document.cookie.split(";");
    for(let i = 0; i < ca.length; i++){
        let c = ca[i];
        while(c.charAt(0) == " ")c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
};
const $e52e951c0fd1bee6$export$84a9c3647d39324f = (name)=>{
    document.cookie = name + "=; Max-Age=-99999999;";
};
const $e52e951c0fd1bee6$export$411a36e344f94698 = window.innerWidth;
const $e52e951c0fd1bee6$export$3f99968195accfaf = (element, to, duration)=>{
    if (duration <= 0) return;
    var difference = to - element.scrollTop;
    var perTick = difference / duration * 10;
    setTimeout(function() {
        element.scrollTop = element.scrollTop + perTick;
        if (element.scrollTop === to) return;
        $e52e951c0fd1bee6$export$3f99968195accfaf(element, to, duration - 10);
    }, 10);
};
const $e52e951c0fd1bee6$export$c091916f1530334c = (el)=>{
    el.style.opacity = 1;
    (function fade() {
        if ((el.style.opacity -= 0.1) < 0) el.style.display = "none";
        else requestAnimationFrame(fade);
    })();
};
const $e52e951c0fd1bee6$export$82e6205b15e6c637 = (el, display)=>{
    el.style.opacity = 0;
    el.style.display = display || "block";
    (function fade() {
        var val = parseFloat(el.style.opacity);
        if (!((val += 0.1) >= 1)) {
            if (!((val += 0.1) > 1)) {
                el.style.opacity = val;
                requestAnimationFrame(fade);
            }
        }
    })();
};
const $e52e951c0fd1bee6$export$4140e97b68e1124c = ()=>{
    const allElements = Array.prototype.slice.call(document.querySelectorAll("*"));
    allElements.push(document);
    allElements.push(window);
    const types = [];
    for(let ev in window)if (/^on/.test(ev)) types[types.length] = ev;
    let elements = [];
    for(let i = 0; i < allElements.length; i++){
        const currentElement = allElements[i];
        for(let j = 0; j < types.length; j++)if (typeof currentElement[types[j]] === "function") elements.push({
            node: currentElement,
            type: types[j],
            func: currentElement[types[j]].toString()
        });
    }
    return elements.sort(function(a, b) {
        return a.type.localeCompare(b.type);
    });
};



const $39f02f97fa132b70$export$10a559a57e887ca6 = ()=>{
    const sweepstakesForm = document.querySelector(".sweepstakes-form .wpcf7");
    const numberFieldError = document.querySelector(".sweepstakes-form .date-requirement.error");
    if ((0, $e52e951c0fd1bee6$export$9d8e10a1281777d0)(sweepstakesForm && numberFieldError)) {
        const numberField = document.querySelector(".sweepstakes-form .wpcf7-date");
        if ((0, $e52e951c0fd1bee6$export$9d8e10a1281777d0)(numberField)) numberField.addEventListener("input", (e)=>{
            const numberFieldValue = e.target.value;
            const currentDate = new Date();
            const userBirthdate = new Date(numberFieldValue);
            const userAge = currentDate.getFullYear() - userBirthdate.getFullYear();
            if ((0, $e52e951c0fd1bee6$export$9d8e10a1281777d0)(userAge)) {
                if (userAge <= 18) {
                    numberFieldError.classList.add("show-error");
                    const sweepstakesFormSubmitBtn = document.querySelector(".sweepstakes-form button");
                    sweepstakesFormSubmitBtn.setAttribute("disabled", "disabled");
                } else {
                    numberFieldError.classList.remove("show-error");
                    const sweepstakesFormSubmitBtn = document.querySelector(".sweepstakes-form button");
                    sweepstakesFormSubmitBtn.removeAttribute("disabled");
                }
            }
        });
    }
};
const $39f02f97fa132b70$export$4c28293574f786cc = ()=>{
    const sweepstakesForm = (0, $e52e951c0fd1bee6$export$d16800b7e59a8051)(".sweepstakes-form .wpcf7");
    const sweepstakesFormModal = (0, $e52e951c0fd1bee6$export$d16800b7e59a8051)(".sweepstakes-form .thank-you-modal");
    if ((0, $e52e951c0fd1bee6$export$9d8e10a1281777d0)(sweepstakesForm)) sweepstakesForm.addEventListener("wpcf7mailsent", function(event) {
        sweepstakesFormModal.classList.add("block");
        document.body.style.overflow = "hidden";
    }, false);
    if ((0, $e52e951c0fd1bee6$export$9d8e10a1281777d0)(sweepstakesFormModal)) sweepstakesFormModal.addEventListener("click", (e)=>{
        if (e.target === sweepstakesFormModal) {
            sweepstakesFormModal.classList.remove("block");
            document.body.style.overflow = null;
        }
    });
};


(0, $e52e951c0fd1bee6$export$28ee1007e174a2a6)(()=>{
    (0, $39f02f97fa132b70$export$10a559a57e887ca6)();
    (0, $39f02f97fa132b70$export$4c28293574f786cc)();
});

})();
//# sourceMappingURL=main.js.map
